import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import { instanciaAxios } from '@/api'
import router from '@/router'

Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    accessToken: '',
    operador: {} // nombre: '', rol: '', atributosRol: [], empresaInquilina: {}
  },

  mutations: {
    ACCESS_TOKEN (state, accessToken) {
      if (accessToken != '') {
        localStorage.setItem ('accessToken', accessToken)
        api.establecerAccessToken (accessToken)
      } else {
        localStorage.clear ()
        api.eliminarAccessToken ()
      }
      state.accessToken = accessToken
    },

    OPERADOR (state, datosOperador) {
      localStorage.setItem ('operador', JSON.stringify (datosOperador))
      state.operador = datosOperador
    },
  },

  actions: {
    async INICIAR_SESION ({commit}, { email, password }) {
      let respuesta = await api.iniciarSesion (email, password)
      if (respuesta.data.accessToken != null) {
        commit ('ACCESS_TOKEN', respuesta.data.accessToken)
        commit ('OPERADOR', respuesta.data.operador)

        console.log(respuesta.data.operador);

        if (respuesta.data.operador.atributosRol.includes('admequ')){
          router.push ("/panel/gestionInstalaciones");
        } else if (respuesta.data.operador.atributosRol.includes('admpar')){
          router.push ("/panel/empresasInquilinas");
        } else if (respuesta.data.operador.atributosRol.includes('des')){
          /* no salto directamente a la pantalla de gestionDescuentos por que necesito haber 
             recibido primero la lista de descuentos vinculables del parking */
          router.push ("/panel");
        }
      }
      return respuesta
    },

    async CERRAR_SESION ({commit}) {
      try {
        await api.cerrarSesion ()
      } catch (e) {
        console.log (`Error al cerrar la sesión: ${e}`)
      }
      commit ('ACCESS_TOKEN', '')
      router.push ('/')
    },

    ESTABLECER_ESTADO_INICIAL ({commit}) {
      const datosOperador = JSON.parse (localStorage.getItem('operador'))
      const accessToken = localStorage.getItem('accessToken')
      if (datosOperador && accessToken) {
        commit ('ACCESS_TOKEN', accessToken)
        commit ('OPERADOR', datosOperador)
      }
    }

  },

  getters: {
    operadorLogado(state) {
      return (state.accessToken != '')
    }
  },

  modules: {
  }
})

// Añadimos un "interceptor" para tratar el error 401 cuando hay un operador logado
instanciaAxios.interceptors.response.use (
  function (response) {
    return response
  },
  function (error) {
    if (401 === error.response.status && store.getters.operadorLogado) {
        // borramos el token de sesion (cerramos la sesion de manera local) y nos vamos a la home page
        store.commit ('ACCESS_TOKEN', '')
        router.push ('/')
        alert ('La sesion ya no es válida. Por favor, ingrese de nuevo')
    } else {
        return Promise.reject(error)
    }
  }
)

export default store